import React from "react"
import { Component } from "react";

import { Link } from "react-router-dom";

//import Maquetado from "./Maquetado";
//import Funcionalidad from "./Funcionalidad"

import Header from "../Header";

import "../../styles/frontend/MateriasFront.css"
import CSSLogo from "../../img/Frontend/00-MateriasFront/CSSLogo.png";
import JSLogo from "../../img/Frontend/00-MateriasFront/JSLogo.png";

import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

import Cookies from "universal-cookie"
import Swal from "sweetalert";
import PropTypes from "prop-types"

import {setLanguage, translate} from 'react-switch-lang';

const HTMLLogo = "https://cdn-icons-png.flaticon.com/512/174/174854.png";

//const JSLogo = "https://cdn-icons-png.flaticon.com/512/5968/5968292.png";
const ReactLogo = "https://cdn-icons-png.flaticon.com/512/1126/1126012.png";

const warnIcon = "https://cdn-icons-png.flaticon.com/512/595/595067.png";

const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5
    },
    desktop: {
      breakpoint: { max: 3000, min: 1365 },
      items: 3
    },
    tablet: {
      breakpoint: { max: 1365, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };


class RenderFront extends Component{

    constructor(props){
        super(props);
        const cookieLanguage = new Cookies('language');
        const lang = cookieLanguage.get('language');
        setLanguage(lang);
        
    }

    handleClickNotPrepared = () =>{
        const {t} = this.props;
        Swal(t("notAvailable.notYet.react"));
    }


    render(){

    const {t} = this.props;
        return (
            <div className="materiasFrontendDH"> 

                <Header urlBack="/My-Portfolio" showIcons={true}/>
                             
                <Carousel responsive={responsive} containerClass="carouselMateriasFrontend">

                    
                    <div className="objetoFilaFrontend">
                        <Link to="/My-Portfolio/frontend/html">
                            <div className="tarjetaFrontend">

                                <div className="divTituloCardFrontend"> 
                                    <h2 className="tituloCardFrontend">HTML + CSS</h2>
                                </div>

                                <div className="contenedorImagenFront1">
                                    <img src={HTMLLogo} alt="HTML+CSS" className="front1Icon htmlIcon"></img>
                                    <img src={CSSLogo} alt="HTML+CSS" className="front1Icon cssIcon"></img>
                                </div>
                            </div>
                        </Link>
                    </div>
                    
                        <div className="objetoFilaFrontend">
                            <Link to="/My-Portfolio/frontend/javascript">
                                <div className="tarjetaFrontend">

                                    <div className="divTituloCardFrontend"> 
                                        <h2 className="tituloCardFrontend">JAVASCRIPT</h2>
                                    </div>

                                    <div className="contenedorImagenFront1">
                                        <img src={JSLogo} className="materiaFront1 jsIcon"></img>
                                    </div>
                                </div>
                            </Link>
                        </div>
                    
                    
                        <div className="objetoFilaFrontend">
                            <div className="tarjetaFrontend" onClick={this.handleClickNotPrepared}>
                                
                                <div className="divTituloCardFrontend"> 
                                    <h2 className="tituloCardFrontend">REACT.JS</h2>
                                </div>

                                <div className="contenedorImagenFront1">
                                    <div  className="divWarnIconReact" >
                                        <img src={warnIcon} className="imgWarnIconReact"/>
                                    </div>

                                    <div className="reactIcon">
                                        <img src={ReactLogo} alt="HTML+CSS" className="materiaFront1 reactIconImg"></img>
                                    </div>
                                </div>
                            </div>
                        </div>
                    
                    </Carousel>

            </div>
        )
    }
}


RenderFront.propTypes = {
    t: PropTypes.func.isRequired,
};


export default translate(RenderFront);